import {Chart} from 'chart.js';
import {round, sumBy} from 'lodash';
import 'chartjs-plugin-doughnutlabel';
import {Component, ElementRef, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';

export interface ChartData {
    data: number;
    label: string;
    color: string;
}

@Component({
    selector: 'app-doughnut',
    templateUrl: './doughnut.component.html',
    styleUrls: ['doughnut.component.css']
})
export class DoughnutComponent implements OnInit, OnChanges {

    @Input()
    dataSet: ChartData[];

    @Input()
    centerText?: string;

    private elementRef: ElementRef;

    constructor(elementRef: ElementRef) {
        this.elementRef = elementRef;
    }

    ngOnInit(): void {
        this.drawChart(this.dataSet);
    }

    ngOnChanges(changes: SimpleChanges): void {
        this.drawChart(this.dataSet);
    }

    calculatePercentageOfShare(data: number): number {
        return round(data / sumBy(this.dataSet, item => item.data) * 100, 2);
    }

    public drawChart(dataSet: ChartData[]) {
        const context = this.elementRef.nativeElement.querySelector(`#doughNutCanvas`);
        const plugins: any = {};

        if (this.centerText) {
            plugins.doughnutlabel = {
                labels: [{
                    color: '#434a53',
                    text: this.centerText,
                    font: {size: '14', units: 'px', family: 'Lato, sans-serif', weight: 'bold'}
                }]
            };
        }
        const cutoutPercentage = this.centerText ? 70 : 50;
        return new Chart(context, {
            data: {
                datasets: [{
                    data: dataSet.map(item => item.data),
                    backgroundColor: dataSet.map(item => item.color),
                }],
                labels: dataSet.map(item => item.label + ' : ' + this.calculatePercentageOfShare(item.data) + '%')
            },
            type: 'doughnut',
            options: {
                legend: {
                    position: 'bottom',
                    labels: {
                        usePointStyle: true,
                        fontFamily: '"Lato", "sans-serif"',
                        fontSize: 11
                    },
                },
                cutoutPercentage: cutoutPercentage,
                tooltips: {
                    callbacks: {
                        label: (tooltipItem, data) => {
                            const index = tooltipItem.index;
                            const ratingLabel = data.labels[index].toString().split(':')[0];
                            const amountLabel = data.datasets[0].data[index];
                            return ratingLabel + ' ' + amountLabel;
                        }
                    }
                },
                plugins: plugins
            }
        });
    }
}
